module.exports = __webpack_public_path__ + "img/icon-receipt-big.0d4ca850.svg";